module.exports = __webpack_public_path__ + "static/media/snukLogin.69226f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snukLogin.png
// module id = 534
// module chunks = 0